import type { FluxErrorEntityErrorCodes } from '../types.js';

export const AutomationActionErrorCodes = {
  AutomationActionAssigneeMustBeGreaterThan1: {
    code: 'automation-action/assignee-must-be-greater-than-1',
    explanation:
      'Para esta ação de automação, é necessário atribuir mais de um responsável. A roleta de responsáveis só pode ser ativada com múltiplos responsáveis.',
    localizations: {},
    message:
      'O número de responsáveis atribuídos deve ser maior do que um para habilitar a roleta.',
  },
  AutomationActionAssigneeRequired: {
    code: 'automation-action/assignee-required',
    explanation:
      'Esta ação de automação requer que pelo menos um responsável seja definido, seja para atribuição direta ou roleta de responsáveis.',
    localizations: {},
    message: 'É necessário definir pelo menos um responsável para esta ação de automação.',
  },
  AutomationActionCreateFailed: {
    code: 'automation-action/create-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar criar a ação de automação. Verifique os dados fornecidos e tente novamente.',
    localizations: {},
    message:
      'Não foi possível criar a ação de automação. Verifique suas informações e tente novamente.',
  },
  AutomationActionMissingRequiredFields: {
    code: 'automation-action/missing-required-fields',
    explanation:
      'Um ou mais campos obrigatórios para esta ação de automação não foram preenchidos. Cada tipo de ação pode ter campos diferentes com requisitos específicos.',
    localizations: {},
    message:
      'Alguns campos obrigatórios não foram preenchidos. Complete as informações e tente novamente.',
    supportingDocs: [
      {
        name: 'Criando sua automação',
        path: '/wiki/docs/automations/criando-sua-automacao',
      },
    ],
  },
  AutomationActionNotFound: {
    code: 'automation-action/not-found',
    explanation: 'A ação de automação que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'A ação de automação especificada não foi encontrada.',
  },
  AutomationActionRequired: {
    code: 'automation-action/required',
    explanation: 'Para continuar com esta operação, é necessário definir uma ação de automação.',
    localizations: {},
    message: 'Uma ação de automação é obrigatória para concluir esta operação.',
  },
  AutomationActionSyncOnlySupportHttpRequest: {
    code: 'automation-action/sync-only-support-http-request',
    explanation:
      'A automação síncrona que você está tentando usar suporta apenas requisições do tipo HTTP.',
    localizations: {},
    message: 'Este tipo de automação síncrona aceita apenas requisições HTTP.',
  },
  AutomationActionSyncOnlySupportPost: {
    code: 'automation-action/sync-only-support-post',
    explanation: 'Para esta automação síncrona, apenas requisições do tipo POST são permitidas.',
    localizations: {},
    message: 'A automação síncrona permite apenas requisições do tipo POST.',
  },
  AutomationActionUpdateFailed: {
    code: 'automation-action/update-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar atualizar a ação de automação. Verifique os dados fornecidos e tente novamente.',
    localizations: {},
    message: 'Erro ao atualizar a ação de automação. Tente novamente mais tarde.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-action'>;

export const AutomationErrorCodes = {
  AutomationCreateFailed: {
    code: 'automation/create-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar criar a automação. Verifique as informações e tente novamente.',
    localizations: {},
    message: 'Falha ao criar a automação.',
  },
  AutomationNotFound: {
    code: 'automation/not-found',
    explanation: 'A automação que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'A automação solicitada não foi encontrada.',
  },
  AutomationRequired: {
    code: 'automation/required',
    explanation: 'Para continuar com esta operação, é necessário definir uma automação.',
    localizations: {},
    message: 'Uma automação é necessária para prosseguir com esta operação.',
  },
  AutomationToggleArchive: {
    code: 'automation/toggle-archive',
    explanation:
      'Ocorreu um erro desconhecido ao tentar arquivar ou desarquivar a automação. Verifique as informações e tente novamente.',
    localizations: {},
    message: 'Não foi possível alterar o status de arquivamento da automação.',
  },
  AutomationUpdateFailed: {
    code: 'automation/update-failed',
    explanation:
      'Ocorreu um erro desconhecido ao tentar atualizar a automação. Verifique as informações e tente novamente.',
    localizations: {},
    message: 'Houve um erro ao atualizar a automação.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation'>;

export const SyncAutomationErrorCodes = {
  SyncAutomationInvalidAutomationExecutionAction: {
    code: 'sync-automation/invalid-automation-execution-action',
    explanation: 'A ação de execução da automação síncrona é inválida.',
    localizations: {},
    message: 'Ação de execução de automação inválida.',
  },
  SyncAutomationInvalidStatus: {
    code: 'sync-automation/invalid-status',
    explanation: 'O status fornecido para a automação síncrona é inválido.',
    localizations: {},
    message: 'O status informado é inválido.',
  },
  SyncAutomationNotFound: {
    code: 'sync-automation/not-found',
    explanation: 'A automação síncrona que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Automação não encontrada.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'sync-automation'>;
